import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import { useLocation } from 'react-router';

export const PageViewTracker = () => {
  const location = useLocation();
  const posthog = usePostHog();
  // Track pageviews
  useEffect(() => {
    if (!posthog) return;

    posthog.capture('$pageview', {
      $current_url: window.origin + location.pathname,
    });
  }, [location]);

  return null;
};
